// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytic-select {
    box-shadow: none;
    border-color: #A4A4A4 !important;

    .p-multiselect-label, .p-dropdown-label {
        font-size: 15px;
        padding: 12px 0 12px 12px;
        color: #000000;
        font-family: SF Pro Display;
        font-weight: 400;
        line-height: 15px;
    }

    &:focus, &:hover, &:active {
        box-shadow: none;
        border-color: #A4A4A4 !important;
    }

    .p-multiselect-clear-icon {
        position: initial;
        width: 8px;
        margin: 0 12px 0 5px;
        outline: none;

        @media (max-width: 480px) {
            margin-right: 14px;
        }
    }

    .p-multiselect-trigger {
        width: max-content !important;
        margin-right: 12px;
    }
}

.analytic-select-panel {
    padding: 14px 12px;
    color: #000000 !important;

    &.p-dropdown-panel {
        padding: 6px;

        .p-dropdown-items {
            padding: 0;
        }
    }

    .p-multiselect-items, .p-dropdown-items {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .p-multiselect-checkbox {
        display: none !important;
    }

    .p-highlight {
        background-color: #E2E5FF;
        color: #000000 !important;
    }

    .p-focus {
        background-color: #d8dcfa;
    }

    .p-dropdown-items-wrapper, .p-multiselect-items-wrapper {
        scrollbar-width: thin !important;
        scrollbar-color: #E9E9E9 transparent !important;
    }

    .p-dropdown-items-wrapper::-webkit-scrollbar, .p-multiselect-items-wrapper::-webkit-scrollbar {
        width: 8px !important;
    }

    .p-dropdown-items-wrapper::-webkit-scrollbar-track, .p-multiselect-items-wrapper::-webkit-scrollbar-track {
        background: transparent !important;
    }

    .p-dropdown-items-wrapper::-webkit-scrollbar-thumb, .p-multiselect-items-wrapper::-webkit-scrollbar-thumb {
        background-color: #E9E9E9 !important;
        border-radius: 4px !important;
    }

    .p-dropdown-items-wrapper::-webkit-scrollbar-thumb:hover, .p-multiselect-items-wrapper::-webkit-scrollbar-thumb:hover {
        background-color: #d0d0d0 !important;
    }

    .p-multiselect-item, .p-dropdown-item {
        border-radius: 10px;
    }

    .p-multiselect-header {
        margin: 5px 0;
        padding: 0;
        border: none;

        .p-multiselect-close, .p-multiselect-select-all, .p-icon {
            display: none;
        }

        .p-multiselect-filter {
            height: 40px;

            &:hover {
                border-color: #E9E9E9 !important;
            }

            &:focus {
                box-shadow: none;
                border-color: #E9E9E9 !important;
            }
        }
    }

    .p-multiselect-item, .p-dropdown-item, .p-focus {
        color: black;
        font-size: 15px;
    }

    .p-dropdown-items {
        min-width: 120px;
    }


    @media (max-width: 768px) {
        left: 5% !important;
        width: 90%;
    }
}

.has-selected-items {
    background: #E2E5FF;
    border: none;

    .p-multiselect-trigger {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Analytics/Filters/dropdown/DropdownSelect.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gCAAgC;;IAEhC;QACI,eAAe;QACf,yBAAyB;QACzB,cAAc;QACd,2BAA2B;QAC3B,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,oBAAoB;QACpB,aAAa;;QAEb;YACI,kBAAkB;QACtB;IACJ;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;;IAEzB;QACI,YAAY;;QAEZ;YACI,UAAU;QACd;IACJ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+CAA+C;IACnD;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,oCAAoC;QACpC,6BAA6B;IACjC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,UAAU;QACV,YAAY;;QAEZ;YACI,aAAa;QACjB;;QAEA;YACI,YAAY;;YAEZ;gBACI,gCAAgC;YACpC;;YAEA;gBACI,gBAAgB;gBAChB,gCAAgC;YACpC;QACJ;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;;IAEZ;QACI,aAAa;IACjB;AACJ","sourcesContent":[".analytic-select {\r\n    box-shadow: none;\r\n    border-color: #A4A4A4 !important;\r\n\r\n    .p-multiselect-label, .p-dropdown-label {\r\n        font-size: 15px;\r\n        padding: 12px 0 12px 12px;\r\n        color: #000000;\r\n        font-family: SF Pro Display;\r\n        font-weight: 400;\r\n        line-height: 15px;\r\n    }\r\n\r\n    &:focus, &:hover, &:active {\r\n        box-shadow: none;\r\n        border-color: #A4A4A4 !important;\r\n    }\r\n\r\n    .p-multiselect-clear-icon {\r\n        position: initial;\r\n        width: 8px;\r\n        margin: 0 12px 0 5px;\r\n        outline: none;\r\n\r\n        @media (max-width: 480px) {\r\n            margin-right: 14px;\r\n        }\r\n    }\r\n\r\n    .p-multiselect-trigger {\r\n        width: max-content !important;\r\n        margin-right: 12px;\r\n    }\r\n}\r\n\r\n.analytic-select-panel {\r\n    padding: 14px 12px;\r\n    color: #000000 !important;\r\n\r\n    &.p-dropdown-panel {\r\n        padding: 6px;\r\n\r\n        .p-dropdown-items {\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    .p-multiselect-items, .p-dropdown-items {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 4px;\r\n    }\r\n\r\n    .p-multiselect-checkbox {\r\n        display: none !important;\r\n    }\r\n\r\n    .p-highlight {\r\n        background-color: #E2E5FF;\r\n        color: #000000 !important;\r\n    }\r\n\r\n    .p-focus {\r\n        background-color: #d8dcfa;\r\n    }\r\n\r\n    .p-dropdown-items-wrapper, .p-multiselect-items-wrapper {\r\n        scrollbar-width: thin !important;\r\n        scrollbar-color: #E9E9E9 transparent !important;\r\n    }\r\n\r\n    .p-dropdown-items-wrapper::-webkit-scrollbar, .p-multiselect-items-wrapper::-webkit-scrollbar {\r\n        width: 8px !important;\r\n    }\r\n\r\n    .p-dropdown-items-wrapper::-webkit-scrollbar-track, .p-multiselect-items-wrapper::-webkit-scrollbar-track {\r\n        background: transparent !important;\r\n    }\r\n\r\n    .p-dropdown-items-wrapper::-webkit-scrollbar-thumb, .p-multiselect-items-wrapper::-webkit-scrollbar-thumb {\r\n        background-color: #E9E9E9 !important;\r\n        border-radius: 4px !important;\r\n    }\r\n\r\n    .p-dropdown-items-wrapper::-webkit-scrollbar-thumb:hover, .p-multiselect-items-wrapper::-webkit-scrollbar-thumb:hover {\r\n        background-color: #d0d0d0 !important;\r\n    }\r\n\r\n    .p-multiselect-item, .p-dropdown-item {\r\n        border-radius: 10px;\r\n    }\r\n\r\n    .p-multiselect-header {\r\n        margin: 5px 0;\r\n        padding: 0;\r\n        border: none;\r\n\r\n        .p-multiselect-close, .p-multiselect-select-all, .p-icon {\r\n            display: none;\r\n        }\r\n\r\n        .p-multiselect-filter {\r\n            height: 40px;\r\n\r\n            &:hover {\r\n                border-color: #E9E9E9 !important;\r\n            }\r\n\r\n            &:focus {\r\n                box-shadow: none;\r\n                border-color: #E9E9E9 !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .p-multiselect-item, .p-dropdown-item, .p-focus {\r\n        color: black;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .p-dropdown-items {\r\n        min-width: 120px;\r\n    }\r\n\r\n\r\n    @media (max-width: 768px) {\r\n        left: 5% !important;\r\n        width: 90%;\r\n    }\r\n}\r\n\r\n.has-selected-items {\r\n    background: #E2E5FF;\r\n    border: none;\r\n\r\n    .p-multiselect-trigger {\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
